import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";

const AllUser = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const { data } = await axios.get(
          "https://backendvpvv-sr72.onrender.com/api/v1/getallClient"
        );
        console.log("Fetched Data", data);

        if (data && data.client) {
          const sortedClients = data.client.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setClients(sortedClients);
        } else {
          setError("No clients data found.");
        }
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch data");
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  const formatClientData = () => {
    return clients.map((client, index) => ({
      "S.No": index + 1,
      "Company Name": client.name || "N/A",
      "SPV Name": client.spvvName || "N/A",
    }));
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatClientData());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");
    XLSX.writeFile(workbook, "ClientsData.xlsx");
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ padding: "20px" }}>
      {/* <button
        onClick={downloadExcel}
        style={{
          padding: "10px",
          marginBottom: "10px",
          borderRadius: "8px",
          backgroundColor: "#4CAF50",
          color: "white",
          border: "none",
          cursor: "pointer",
        }}
      >
        Download Excel
      </button> */}
      <table
        style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>S.No</th>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              Company Name
            </th>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              SPV Name
            </th>
          </tr>
        </thead>
        <tbody>
          {formatClientData().map((client, index) => (
            <tr key={index}>
              <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                {client["S.No"]}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                {client["Company Name"]}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                {client["SPV Name"]}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllUser;
